import styled from "styled-components";

import { Button as ButtonDefault } from "ds/Button";
import * as Sticker from "ds/Sticker";

export const FailedActivityStickerRoot = styled(Sticker.Root)`
  margin-bottom: 45px;

  & > :nth-child(2) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const Button = styled(ButtonDefault)`
  font-size: 13px;
`;
export const StickerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
